import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import ApiServices from "../../service/api/ApiServices";
import { failureToast } from "../Common/CommonFunctions";
import { SubAnalyticalStat } from "../NewAnalytics.js/SubAnalyticalStat";
import { Toolbar } from "primereact/toolbar";
import { Dropdown } from "primereact/dropdown";
import { TabView } from "primereact/tabview";
import { TabPanel } from "primereact/tabview";
import { SalesMembers } from "./SalesMembers";
import { SalesPersonStats } from "./SalesPersonStats";
import CommonCal from "../../service/common/CommonCal";
import { Customers } from "./Customers";
import { SalesMemberOrders } from "./SalesMemberOrders";

const saved = localStorage.getItem("user");


// Parse the saved user data from localStorage.
// This is typically used to get user information or authentication details.
const initialValue = JSON.parse(saved);

// Create an instance of ApiServices to use its methods for API calls.
// Assuming ApiServices is a class that handles API requests.
const apiServices = new ApiServices()
const commonCal = new CommonCal()


export const GSFDashboard = () => {

    const [totalSales, setTotalSales] = useState(0);
    const [totalEarning, setTotalEarning] = useState(0);
    const [totalCustomer, setTotalCustomer] = useState(0);
    const [totalOrders, setTotalOrders] = useState(0);
    const [loading, setLoading] = useState(false)
    const [selectedSalesMember, setSelectedSalesMember] = useState({ full_name: "All", code: 'all' });
    const [selectedDuration, setSelectedDuration] = useState(null);
    const [salesMembersList, setSalesMembersList] = useState([]);

    const [timeselectValue, setTimeselectValue] = useState({ name: 'This Week', code: 'this_week' });
    const [datesData, setDatesData] = useState({ startDate: '', endDate: '' });
    const [daywiseStats, setDaywiseStats] = useState([]);



    // Define the options for the duration dropdown.
    // This array contains different time periods that can be selected for filtering sales data.
    const TimeSelectValues = [
        { name: 'All', code: 'all' },
        { name: 'Today', code: 'today' },
        { name: 'Yesterday', code: 'yesterday' },
        { name: 'This Week', code: 'this_week' },
        { name: 'This Month', code: 'this_month' },
        { name: 'Last Month', code: 'last_month' },
        // { name: 'Custom', code: 'custom' }
    ]




    useEffect(() => {
        // This effect runs once when the component mounts.
        // It fetches the sales members data by calling the getSalesMembers function.
        getData();
        getSalesMembers({});
        // The empty dependency array means this effect will only run once after the initial render.
        // If you want to run it again based on some state or props, you can add them to this array.
        getDates();
    }, [])


    /**
     * Function to fetch data from the API.
     * This function is called when the component mounts to retrieve sales data.
     * @param {*} data 
     */
    const getData = async (data = {}) => {
        setLoading(true)
        const response = await apiServices.getGSFData(data)   // Assuming this API returns the sales 
        // members data
        if (response?.data?.response_obj) {
            setTotalCustomer(response.data.response_obj.TotalCustomers || 0);
            setTotalEarning(response.data.response_obj.TotalEarnings || 0);
            setTotalOrders(response.data.response_obj.TotalOrders || 0);
            setTotalSales(response.data.response_obj.TotalSales || 0);
            setDaywiseStats(response.data.response_obj.daywiseStats || []);
        } else {
            // If the API call fails or returns an error, you can handle it here.
            // For example, you might want to show a toast notification or log the error.
            failureToast("Failed to fetch data");
        }
        setLoading(false)
    }

    // Function to handle changes in the duration dropdown.
    // This function updates the selected duration state and fetches data based on the selected duration.
    const OnChangeTypeValue = (e) => {
        const data = {}
        const today = { startDate: datesData.startToday, endDate: new Date() };
        const yesterday = { startDate: datesData.YestStart, endDate: datesData.EndStart };
        const thisWeek = { startDate: datesData.weekstart, endDate: datesData.weekEnd };
        const thisMonth = { startDate: datesData.monthStart, endDate: datesData.endThisMonth };
        const lastMonth = { startDate: datesData.lastStart, endDate: datesData.lastend };

        if (e.value.code == "all") {
            data.duration = 'all';
        } else if (e.value.code == "today") {
            data.date = today;
        } else if (e.value.code == "yesterday") {
            data.date = yesterday;
        } else if (e.value.code == "this_week") {
            data.date = thisWeek;
        } else if (e.value.code == "this_month") {
            data.date = thisMonth;
        } else if (e.value.code == "last_month") {
            data.date = lastMonth;
        }

        setTimeselectValue(e.value);
        setSelectedDuration(data.date);
        getData({ duration: e.value.code, ...data, salesPerson_id: selectedSalesMember.code === 'all' ? '' : selectedSalesMember.id });
    }

    // Template for the left toolbar, which includes a button and a dropdown for selecting sales Members.
    // This is used to filter or select sales Members in the dashboard.
    const leftToolbarTemplate = () => {
        return (
            <>
                <div className="p-inputgroup p-m-0">
                    <Button className='custom-group-btn' label="Select Sales Member" tooltip="Sales Members" />
                    <Dropdown id='select-mc' value={selectedSalesMember} onChange={onChangesalesMember} options={[{ full_name: "All", code: 'all' },...salesMembersList.filter((person)=>person.salesPerson_id)]} optionLabel="full_name" placeholder="Select Sales Member" filter className="p-mr-2 p-p-1 multiselect-custom " />
                </div>
            </>
        )
    }

    // Template for the right toolbar, which includes a button and a dropdown for selecting duration.
    // This is used to filter or select the duration for the sales data in the dashboard.
    const rightToolbarTemplate = () => {
        return (
            <>
                <div className="p-inputgroup p-m-0">
                    <Button className='custom-group-btn' label="Duration" tooltip="Duration" />
                    <Dropdown id='select-mc' value={timeselectValue} onChange={OnChangeTypeValue} options={TimeSelectValues} optionLabel="name" placeholder="Duration" filter className="p-mr-2 p-p-1 multiselect-custom " />
                </div>
            </>
        )
    }

    const onChangesalesMember = (salesPerson) => {
        console.log(salesPerson);
        // Check if salesPerson and ID exist before calling getData
        if (salesPerson?.value?.id) {
            getData({ salesPerson_id: salesPerson.value.id, date: selectedDuration });
        } else {
            getData({ date: selectedDuration });
        }
        setSelectedSalesMember(salesPerson.value);

        // This function is called when the selected sales Member changes in the dropdown.
        // It updates the state with the selected sales Member and fetches data based on that selection.
    };


    /**
     * Function to fetch sales members data from the API
     * and update the state with the fetched data.
     */
    const getSalesMembers = async (data = {}) => {
        setLoading(true)
        const response = await apiServices.getGSFSalesMembers(data)   // Assuming this API returns the sales members data
        if (response?.data?.response_obj.length > 0) {
            let data = response?.data?.response_obj;
            data = data.map((obj) => ({
                ...obj,
                full_name: obj.first_name + ' ' + obj.last_name
            }));
            setSalesMembersList([{ full_name: "All", code: 'all' }, ...data])
        } else {
            setSalesMembersList([])
        }
        setLoading(false)
    }

    const getDates = async () => {
        const response = commonCal.getDates()
        // console.log(response);
        setDatesData(response);

        let data = {};

        const today = { startDate: response.startToday, endDate: new Date() };
        const yesterday = { startDate: response.YestStart, endDate: response.EndStart };
        const thisWeek = { startDate: response.weekstart, endDate: response.weekEnd };
        const thisMonth = { startDate: response.monthStart, endDate: response.endThisMonth };
        const lastMonth = { startDate: response.lastStart, endDate: response.lastend };

        if (timeselectValue.code == "all") {
            data.duration = 'all';
        } else if (timeselectValue.code == "today") {
            data.date = today;
        } else if (timeselectValue.code == "yesterday") {
            data.date = yesterday;
        } else if (timeselectValue.code == "this_week") {
            data.date = thisWeek;
        } else if (timeselectValue.code == "this_month") {
            data.date = thisMonth;
        } else if (timeselectValue.code == "last_month") {
            data.date = lastMonth;
        }

        setTimeselectValue(timeselectValue);
        setSelectedDuration(data.date);
        getData({ duration: timeselectValue.code, ...data, salesPerson_id: selectedSalesMember.code === 'all' ? '' : selectedSalesMember.id });
    }


    return (

        <>
            <div className="p-grid crud-demo">
                <Toolbar className="p-toolbar p-col-12" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>

                <SubAnalyticalStat icon="pi pi-money-bill" header="Total Sales" value={totalSales} />
                <SubAnalyticalStat icon="pi pi-chart-line" header="Total Commision" value={totalEarning} />
                <SubAnalyticalStat icon="pi pi-shopping-cart" header="Total Orders" value={totalOrders} />
                <SubAnalyticalStat icon="pi pi-users" header="Total Customers" value={totalCustomer} />
            </div>

            <div className="card">
                <TabView>
                    <TabPanel header="Sales Members Statistics">
                        <SalesPersonStats daywiseStats={daywiseStats} />
                    </TabPanel>
                    <TabPanel header="Customers">
                        <Customers data={selectedSalesMember} />
                    </TabPanel>
                    <TabPanel header="Orders">
                        <SalesMemberOrders data={selectedSalesMember} />
                    </TabPanel>
                    <TabPanel header="Sales Persons">
                        <SalesMembers data={selectedSalesMember} />
                    </TabPanel>
                </TabView>
            </div>
        </>
    )
}